// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e8764360","977":"7baa5398"}[chunkId] + ".chunk.js";
};